import { useState } from 'react';
import { IUpsertCheckIn } from '../interfaces/checkIn';
import { checkInServices } from '../services';

const useCheckIn = () => {
  const [isUpsertCheckIn, setIsUpsertCheckIn] = useState<boolean>(false);

  const upsertCheckIn = async (payload: IUpsertCheckIn) => {
    let result = null;
    try {
      setIsUpsertCheckIn(true);
      result = await checkInServices.upsertCheckIn(payload);
    } catch (e) {
      result = null;
    } finally {
      setIsUpsertCheckIn(false);
    }

    return result;
  };

  return {
    isUpsertCheckIn,
    upsertCheckIn,
  };
};

export default {
  useCheckIn,
};
